import React from 'react';
import { Box, Typography } from '@mui/material';
import styles from './InvoiceEditLineItemHeader.module.scss';
import classNames from 'classnames';

type InvoiceEditLineItemHeaderProps = {
	isMobile?: boolean;
	isMutable: boolean;
	rateLabel: string;
};

export const InvoiceEditLineItemHeader = ( {
	isMobile,
	isMutable,
	rateLabel,
}: InvoiceEditLineItemHeaderProps ) =>
	isMobile ? null : (
		<Box
			className={ classNames( styles.headerContainer, {
				[ styles.immutable ]: !isMutable,
			} ) }
			data-cy='invoice-edit-line-items-header'
		>
			{ isMutable ? <span></span> : null }
			<Typography component='div' data-cy='invoice-edit-line-item-name-header'>
				Name
			</Typography>
			<Typography component='div' data-cy='invoice-edit-line-item-rate-header'>
				{ rateLabel }
			</Typography>
			<Typography
				component='div'
				data-cy='invoice-edit-line-item-quantity-header'
			>
				Quantity
			</Typography>
			<Typography component='div' data-cy='invoice-edit-line-item-tax-header'>
				Tax
			</Typography>
			<Typography component='div' data-cy='invoice-edit-line-item-total-header'>
				Line total
			</Typography>
			<span></span>
		</Box>
	);
